import request from '@/router/axios'

export function getPage(query) {
    return request({
        url: '/chain/matchplan/getProjectMatchList',
        method: 'get',
        params: query
    })
}

export function addObj(obj) {
    return request({
        url: '/chain/matchplan/postPlan',
        method: 'post',
        data: obj
    })
}
export function pause(id) {
    return request({
        url: '/chain/matchplan/pause/'+id,
        method: 'get',
    })
}
export function renew(id) {
    return request({
        url: '/chain/matchplan/renew/'+id,
        method: 'get',
    })
}
export function getFleetList() {
    return request({
        url: '/chain/driverfleet/list',
        method: 'get',
    })
}

export function getPoolPage(params) {
  return request({
      url: '/chain/matchplanpool/getPoolPage',
      method: 'get',
      params
  })
}
//邀请
export function invite(id,scene) {
  return request({
      url: `/chain/matchplanpool/invite/${id}/${scene}`,
      method: 'get',
  })
}
//接受邀请
export function acceptInvite(id,scene) {
  return request({
      url: `/chain/matchplanpool/receive/${id}/${scene}`,
      method: 'get',
  })
}
//取消邀请
export function cancelInvite(id) {
  return request({
      url: `/chain/matchplanpool/cancel/${id}`,
      method: 'get',
  })
}
//匹配刷新
export function matchRefresh(params) {
  return request({
      url: `/chain/matchplanpool/fleetRecommendProjectMatchPlan`,
      method: 'get',
      params
  })
}
//发布撮合计划校验是否实名并且绑定银行卡
export function checkAuthForMatchPlan(data) {
  return request({
      url: `/chain/driverauthentication/checkAuthForMatchPlan`,
      method: 'post',
      data
  })
}
//重新报价
export function matchplanpoollatestoffer(data) {
  return request({
      url: `/chain/matchplanpoollatestoffer`,
      method: 'post',
      data
  })
}
